import styled from 'styled-components';
export const StyledPayoutListElement = styled.div`
  display: flex;

  margin-bottom: 0.2rem;

  &:last-child {
    margin-bottom: 1rem;
  }
  .payout-list-element-col {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-basis: 17rem;

    padding: 0.4rem;

    word-break: break-all;

    border-right: 1px solid
      ${(props) => (props.theme.id === 'dark' ? props.theme.text3 : props.theme.accent4)};

    font-size: 1rem;
    font-weight: 600;
    line-height: 150%;
    text-align: center;

    background-color: ${(props) => (props.theme.id === 'dark' ? props.theme.bg2 : props.theme.bg1)};

    &:last-child {
      border-right: none;
    }

    &.date-time {
      .time {
        display: none;

        @media screen and (min-width: 768px) {
          display: inline;
        }
      }
    }

    @media screen and (min-width: 768px) {
      flex-basis: 17rem;

      padding: 1rem;

      &.amount {
        flex-basis: 14rem;
        flex-shrink: 0;
      }
      &.txid {
        flex-basis: 14rem;
        flex-shrink: 0;
      }
      &.id {
        flex-basis: 20rem;
        flex-shrink: 0;
        flex-grow: 1;
      }

      &.confirmation {
        flex-basis: 9rem;
        flex-shrink: 0;
        flex-grow: 0;
      }
    }

    @media screen and (min-width: 1024px) {
      font-size: 1.4rem;
      &[class] {
        flex-basis: 36.1rem;
        flex-shrink: 1;
      }
    }

    .status-icon {
      display: flex;

      width: 1.5rem;
      height: 1.5rem;

      margin: auto;

      @media screen and (min-width: 768px) {
        width: 2.4rem;
        height: 2.4rem;
      }

      > * {
        width: 100%;
        height: 100%;
      }
    }
  }
  &:hover,
  &.selected {
    .payout-list-element-col {
      background-color: ${(props) =>
        props.theme.id === 'dark' ? props.theme.bg6 : props.theme.accent4};
    }
  }
`;
